export default {
    data() {
        return {
            modificationPresent: (typeof this.modification?.extras_result !== 'undefined' || this.modification?.extras?.length > 0),
            modificationSelected: null,
            count: 0,
        }
    },

    watch: {
        prepaySelected(value) {
            this.prepay = value === true ? 1 : 0;
        },
        modificationSelected() {
            this.modificationPresent = (typeof this.modification?.extras_result !== 'undefined' || this.modification?.extras?.length > 0);
        }
    },
    computed: {
        min() {
            return Math.min.apply(Math, this.extra.choices);
        },
        max() {
            return Math.max.apply(Math, this.extra.choices);
        },
        selectedExtras() {
            return this.$store.getters.getSelectedExtras;
        },
        selectedCurrency() {
            return this.$store.getters.selectedCurrency;
        },
        pricePerDay() {
            return this.prepay ? this.extra.prepay_price_per_day : this.extra.price_per_day;
        },
        isSelected() {
            let selected = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id === this.extra.id;
            });

            return selected.length > 0;
        },
        choice() {
            const selectedExtraObjects = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id === this.extra.id;
            });

            return selectedExtraObjects.length ? parseInt(selectedExtraObjects[0].choice) : 0;
        },
        bothPaymentOptionsAvailable() {
            return this.extra.prepay_available && this.extra.pay_on_arrival_available;
        },
        availablePaymentOptionLabel() {
            if (this.extra.pay_on_arrival_available) {
                return 'booking-process.shared.pay_on_arrival_label';
            }

            return 'booking-process.shared.pay_online_label';
        },
        prepaySelected() {
            const selectedExtraObjects = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id === this.extra.id;
            });

            return selectedExtraObjects.length ? selectedExtraObjects[0].prepay : this.defaultPrepayValue;
        },
        defaultPrepayValue() {
            return this.extra.prepay_available;
        },
        numberStepperButtonLabel() {
            return this.isSelected
                ? 'booking-process.options_selection.remove_option_label'
                : 'booking-process.options_selection.add_option_label';
        },
        isFree() {
            let isFree = [];

            if (typeof this.selectedExtras !== 'undefined') {
                for (let i = 0; i < this.selectedExtras.length; i++) {
                    if (this.selectedExtras[i].quote_extra_id === this.extra.id && this.selectedExtras[i].free ) {
                        isFree.push(this.selectedExtras[i]);
                    }
                }
            }

            if (typeof this.modification !== 'undefined' && typeof this.modification.extras !== 'undefined') {
                for (let i = 0; i < this.modification.extras.length; i++) {
                    if (this.modification?.extras[i].id === this.extra.id && this.modification?.extras[i].free ) {
                        isFree.push(this.modification.extras[i]);
                    }
                }
            }

            return isFree.length > 0;
        },
    },

    methods: {
        toggleExtra(selected) {
            if (
              (typeof this.$route !== 'undefined' && this.$route.params.booking)
              && (this.quote?.id === this.booking?.quote_id)
            ) {
                return this.$store.dispatch('updateExtrasWithBooking', {
                    selected: selected,
                    extra: this.extra,
                    bookingId: this.booking.id,
                    booking_reference: this.booking.reference,
                    quoteId: this.quote.id,
                }).then((response) => {
                    this.modificationSelected = false;
                    for (let i = 0; i < response.data.data[0].extras.length; i++) {
                        if (response.data.data[0].extras[i].id === this.extra.id) {
                            this.modificationSelected = true;
                        }
                    }
                });
            } else {
                if (this.isSelected) {
                    return this.$store.dispatch('deleteExtra', this.extra);
                } else {
                    return this.$store.dispatch(
                      'createExtra',
                      { extra: this.extra, prepay: this.prepaySelected }
                    );
                }
            }
        },
        updateExtraChoice(choice) {
            if (choice !== this.choice) {
                this.$store.dispatch('updateExtra', { extra: this.extra, choice: choice, prepay: this.prepaySelected });
            }
        },
        updateExtraPrepayStatus(prepay) {
            if (this.isSelected) {
                this.$store.dispatch('updateExtra', { extra: this.extra, prepay: prepay });
            }
        },
        fixedPriceForBookingTerm(extra) {
            return extra.price_per_day === extra.total_price;
        },
    },
}
